let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bFOLQ")).then(() => parcelRequire('jz6EW'));